@switch (bannerType()) {
  @case ('bonus-verified') {
    <div class="logo" [ngClass]="bannerType()"></div>

    <div class="banner">
      <span [innerHTML]="text()"></span>
    </div>

    <svg-icon-sprite
      src="./assets/img/icons/sprite.svg#chevron"
      class="icon"
      width="14px"
      height="14px">
    </svg-icon-sprite>
  }
  @case ('bonus-unverified') {
    <div class="banner banner--unverified">
      <span [innerHTML]="text()"></span>
    </div>

    <svg-icon-sprite
      (click)="close($event)"
      [src]="'./assets/img/icons/sprite.svg#cross'"
      class="close">
    </svg-icon-sprite>
  }
}
